import { render, staticRenderFns } from "./ProductInfoForm.vue?vue&type=template&id=bd07f6a2&scoped=true"
import script from "./ProductInfoForm.vue?vue&type=script&lang=js"
export * from "./ProductInfoForm.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoForm.vue?vue&type=style&index=0&id=bd07f6a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd07f6a2",
  null
  
)

export default component.exports